import jplistCore from '../../js/jplist.core.min.js?raw';
import jplistFilterDropdown from '../../js/jplist.filter-dropdown-bundle.min.js?raw';
import jplistPagination from '../../js/jplist.pagination-bundle.min.js?raw';
import jplistSort from '../../js/jplist.sort-bundle.min.js?raw';
import jplistFilterToggle from '../../js/jplist.filter-toggle-bundle.min.js?raw';
import {injectLegacyScripts} from '../shared/inject-legacy-script';
import {initFlexsliderBanner} from '../shared/flexslider-banner';
import {initLegacyTabs} from '../shared/legacy-tabs';
import {initBannerImagePopup} from '../shared/popups';
import {initPropertyList, installPropertyListPaginationGlobals} from '../shared/property-list';

injectLegacyScripts([
    jplistCore,
    jplistFilterDropdown,
    jplistPagination,
    jplistSort,
    jplistFilterToggle
]);

var $ = window.jQuery;

function clearLegacyPropertyListCookies()
{
    document.cookie.split(';').forEach(function (cookie) {
        var name = cookie.split('=')[0].trim();

        if (name === 'jplist-div-layout' || name.indexOf('jplist-resort-') === 0) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        }
    });
}

if ($) {
    $(document).ready(function () {
        var noResultsMessage = document.querySelector('[data-jplist-no-results-message]');

        if (noResultsMessage && !noResultsMessage.textContent.trim()) {
            noResultsMessage.textContent = 'No results found';
        }

        initLegacyTabs();
        clearLegacyPropertyListCookies();
        initPropertyList({
            storage: ''
        });
        installPropertyListPaginationGlobals();

        $('.breadcrumb-container .right-content a').on('click', function (event) {
            event.preventDefault();
            $(this).toggleClass('open');
            $('html, body').animate({scrollTop: 0}, 'slow');
            $('.site-search .container').toggleClass('open');
        });

        $('.flexslider a').on('click', function (event) {
            if (!$(event.target).closest('.flex-active-slide').length) {
                return false;
            }
        });
    });
}

initBannerImagePopup();
initFlexsliderBanner('.flexslider', {
    maxSlidesHeight: 743
});
